var React = require('react');

function FrownOpen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM136,208a32,32,0,1,1,32,32A32,32,0,0,1,136,208ZM323.3,391.3C292.1,381.7,263.9,376,248,376s-44.1,5.7-75.3,15.3a16,16,0,0,1-20.5-18.1c7-40,60.1-61.2,95.8-61.2s88.8,21.3,95.8,61.2a16,16,0,0,1-20.5,18.1ZM328,240a32,32,0,1,1,32-32A32,32,0,0,1,328,240Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M168,176a32,32,0,1,0,32,32A32,32,0,0,0,168,176Zm160,0a32,32,0,1,0,32,32A32,32,0,0,0,328,176Z","className":"fa-primary","key":2})]);
}

FrownOpen.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = FrownOpen;

FrownOpen.default = FrownOpen;
